module.exports = __webpack_public_path__ + "img/shape_hearth.0801008.png";